import { News } from '@/types/community/news';

export const newsItems: News[] = [
  {
    id: 'NEWS001',
    title: 'Community Pool Renovation',
    description: 'The community pool will be undergoing renovation from March 15th to April 15th. During this time, the pool will be closed for maintenance and upgrades.',
    category: 'general',
    status: 'published',
    author: {
      id: 'EMP001',
      name: 'Community Manager',
      type: 'employee',
      profilePicture: {
        id: 'PROF001',
        name: 'community_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP001/community_manager.jpg',
        url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-01T10:00:00'),
    expiryDate: new Date('2024-04-15T23:59:59'),
    liked: {
      count: 12,
      users: [
        { id: 'RES001', name: 'John Smith' },
        { id: 'RES002', name: 'Jane Smith' }
      ]
    },
    comments: [
      {
        content: 'Great news! The pool really needs renovation.',
        author: { id: 'RES001', name: 'John Smith', type: 'resident' },
        createdAt: new Date('2024-03-01T11:00:00')
      }
    ],
    photos: [
      {
        id: 'PHOTO001',
        name: 'pool_renovation.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS001/pool_renovation.jpg',
        url: 'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-01T10:00:00')
      }
    ],
    attachments: [
      {
        id: 'ATT001',
        name: 'pool_renovation_plan.pdf',
        type: 'application/pdf',
        size: 2048,
        path: '/documents/news/NEWS001/pool_renovation_plan.pdf',
        url: 'https://example.com/docs/pool_renovation.pdf',
        uploadedAt: new Date('2024-03-01T10:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS002',
    title: 'New Fitness Center Opening',
    description: 'We are excited to announce the opening of our new state-of-the-art fitness center. The facility includes modern equipment and will be open 24/7.',
    category: 'amenities',
    status: 'published',
    author: {
      id: 'EMP001',
      name: 'Community Manager',
      type: 'employee',
      profilePicture: {
        id: 'PROF001',
        name: 'community_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP001/community_manager.jpg',
        url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-05T14:00:00'),
    expiryDate: new Date('2024-04-05T23:59:59'),
    liked: {
      count: 8,
      users: [
        { id: 'RES003', name: 'Mike Johnson' },
        { id: 'RES004', name: 'Sarah Wilson' }
      ]
    },
    comments: [],
    photos: [
      {
        id: 'PHOTO002',
        name: 'fitness_center.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS002/fitness_center.jpg',
        url: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-05T14:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS003',
    title: 'Monthly Community Meeting',
    description: 'Join us for our monthly community meeting on March 20th at 7 PM in the clubhouse. We will discuss upcoming projects and address resident concerns.',
    category: 'event',
    status: 'published',
    author: {
      id: 'EMP002',
      name: 'Assistant Manager',
      type: 'employee',
      profilePicture: {
        id: 'PROF002',
        name: 'assistant_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP002/assistant_manager.jpg',
        url: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-10T09:00:00'),
    expiryDate: new Date('2024-03-21T23:59:59'),
    liked: {
      count: 15,
      users: [
        { id: 'RES005', name: 'David Brown' },
        { id: 'RES006', name: 'Amanda Martinez' }
      ]
    },
    comments: [
      {
        content: 'I\'ll be there! We have some important issues to discuss.',
        author: { id: 'RES005', name: 'David Brown', type: 'resident' },
        createdAt: new Date('2024-03-10T10:00:00')
      }
    ],
    photos: [
      {
        id: 'PHOTO003',
        name: 'community_meeting.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS003/community_meeting.jpg',
        url: 'https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-10T09:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS004',
    title: 'Parking Policy Update',
    description: 'Updated parking policies will be effective from April 1st. Please review the new guidelines and ensure compliance.',
    category: 'policies',
    status: 'published',
    author: {
      id: 'EMP001',
      name: 'Community Manager',
      type: 'employee',
      profilePicture: {
        id: 'PROF001',
        name: 'community_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP001/community_manager.jpg',
        url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-12T11:00:00'),
    expiryDate: new Date('2024-04-12T23:59:59'),
    photos: [
      {
        id: 'PHOTO004',
        name: 'parking_policy.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS004/parking_policy.jpg',
        url: 'https://images.unsplash.com/photo-1549924231-f129b911e442?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-12T11:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS005',
    title: 'Spring Cleaning Schedule',
    description: 'Spring cleaning schedule for common areas has been posted. Please check the notice board for your block\'s assigned dates.',
    category: 'safety',
    status: 'published',
    author: {
      id: 'EMP003',
      name: 'Maintenance Supervisor',
      type: 'employee',
      profilePicture: {
        id: 'PROF003',
        name: 'maintenance_supervisor.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP003/maintenance_supervisor.jpg',
        url: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-15T08:00:00'),
    expiryDate: new Date('2024-04-15T23:59:59'),
    photos: [
      {
        id: 'PHOTO005',
        name: 'spring_cleaning.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS005/spring_cleaning.jpg',
        url: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-15T08:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS006',
    title: 'Security System Upgrade',
    description: 'We are upgrading our security system to enhance resident safety. Installation will begin next week and may cause temporary disruptions.',
    category: 'security',
    status: 'published',
    author: {
      id: 'EMP001',
      name: 'Community Manager',
      type: 'employee',
      profilePicture: {
        id: 'PROF001',
        name: 'community_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP001/community_manager.jpg',
        url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-18T16:00:00'),
    expiryDate: new Date('2024-04-18T23:59:59'),
    photos: [
      {
        id: 'PHOTO006',
        name: 'security_system.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS006/security_system.jpg',
        url: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-18T16:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS007',
    title: 'Community Garden Opening',
    description: 'Our new community garden is now open! Residents can reserve plots for gardening. Contact the office for registration.',
    category: 'amenities',
    status: 'published',
    author: {
      id: 'EMP002',
      name: 'Assistant Manager',
      type: 'employee',
      profilePicture: {
        id: 'PROF002',
        name: 'assistant_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP002/assistant_manager.jpg',
        url: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-20T10:00:00'),
    expiryDate: new Date('2024-04-20T23:59:59'),
    photos: [
      {
        id: 'PHOTO007',
        name: 'community_garden.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS007/community_garden.jpg',
        url: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-20T10:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS008',
    title: 'Internet Service Maintenance',
    description: 'Scheduled maintenance for internet services will be conducted on March 25th from 2 AM to 4 AM. Service interruptions may occur.',
    category: 'safety',
    status: 'published',
    author: {
      id: 'EMP003',
      name: 'Maintenance Supervisor',
      type: 'employee',
      profilePicture: {
        id: 'PROF003',
        name: 'maintenance_supervisor.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP003/maintenance_supervisor.jpg',
        url: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-22T12:00:00'),
    expiryDate: new Date('2024-03-26T23:59:59'),
    photos: [
      {
        id: 'PHOTO008',
        name: 'internet_maintenance.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS008/internet_maintenance.jpg',
        url: 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-22T12:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS009',
    title: 'Resident Appreciation Day',
    description: 'Join us for Resident Appreciation Day on March 30th! Free food, games, and entertainment for all residents.',
    category: 'event',
    status: 'published',
    author: {
      id: 'EMP001',
      name: 'Community Manager',
      type: 'employee',
      profilePicture: {
        id: 'PROF001',
        name: 'community_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP001/community_manager.jpg',
        url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-25T15:00:00'),
    expiryDate: new Date('2024-03-31T23:59:59'),
    photos: [
      {
        id: 'PHOTO009',
        name: 'resident_appreciation.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS009/resident_appreciation.jpg',
        url: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-25T15:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'NEWS010',
    title: 'Emergency Contact Information',
    description: 'Please ensure your emergency contact information is up to date. This is crucial for your safety and our ability to reach you in emergencies.',
    category: 'safety',
    status: 'published',
    author: {
      id: 'EMP001',
      name: 'Community Manager',
      type: 'employee',
      profilePicture: {
        id: 'PROF001',
        name: 'community_manager.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/profiles/EMP001/community_manager.jpg',
        url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        uploadedAt: new Date('2024-01-15T10:00:00')
      }
    },
    publishDate: new Date('2024-03-28T09:00:00'),
    expiryDate: new Date('2024-04-28T23:59:59'),
    photos: [
      {
        id: 'PHOTO010',
        name: 'emergency_contact.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/photos/news/NEWS010/emergency_contact.jpg',
        url: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=400&fit=crop',
        uploadedAt: new Date('2024-03-28T09:00:00')
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  }
]; 